import { customAlphabet } from 'nanoid/non-secure';

/**
 * Generates a 7-character random string to use for IDs. Not secure.
 */
export const generateShortId = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', 7);
